// @flow
import type {
  OrdersOperator,
} from '../types'

// Constants
import { MODEL } from 'hfty-model-orders'

// Libs
import composeOperator from 'fc-operations'

// Exports
export const operator: OrdersOperator = composeOperator({
  model: MODEL,
})

export default operator
